import "./async.js";
import { e as ensure_array_like, c as attr_class, b as escape_html } from "./renderer.js";
import { T as Tooltip } from "./Tooltip.js";
function TooltipTable($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    let { columns, rows, children, hideHeader } = $$props;
    let showTooltip = false;
    {
      let trigger = function($$renderer3) {
        $$renderer3.push(`<button class="dotted text-center">`);
        children?.($$renderer3);
        $$renderer3.push(`<!----></button>`);
      }, content = function($$renderer3) {
        $$renderer3.push(`<table class="w-full border-collapse text-base font-medium">`);
        if (!hideHeader) {
          $$renderer3.push("<!--[0-->");
          $$renderer3.push(`<thead><tr><!--[-->`);
          const each_array = ensure_array_like(columns);
          for (let index = 0, $$length = each_array.length; index < $$length; index++) {
            let column = each_array[index];
            $$renderer3.push(`<th${attr_class("px-2 py-1 border-b border-[var(--color-3)] bg-[var(--color-4)] font-bold", void 0, {
              "text-left": column.align === "left" || !column.align,
              "text-right": column.align === "right",
              "text-center": column.align === "center"
            })}>${escape_html(column.header)}</th>`);
          }
          $$renderer3.push(`<!--]--></tr></thead>`);
        } else {
          $$renderer3.push("<!--[-1-->");
        }
        $$renderer3.push(`<!--]--><tbody><!--[-->`);
        const each_array_1 = ensure_array_like(rows);
        for (let rowIndex = 0, $$length = each_array_1.length; rowIndex < $$length; rowIndex++) {
          let row = each_array_1[rowIndex];
          $$renderer3.push(`<tr><!--[-->`);
          const each_array_2 = ensure_array_like(columns);
          for (let index = 0, $$length2 = each_array_2.length; index < $$length2; index++) {
            let column = each_array_2[index];
            $$renderer3.push(`<td${attr_class("px-2 py-1", void 0, {
              "border-b": rowIndex < rows.length - 1,
              "border-[var(--color-3)]": rowIndex < rows.length - 1,
              "text-left": column.align === "left" || !column.align,
              "text-right": column.align === "right",
              "text-center": column.align === "center"
            })}>${escape_html(row[column.key])}</td>`);
          }
          $$renderer3.push(`<!--]--></tr>`);
        }
        $$renderer3.push(`<!--]--></tbody></table>`);
      };
      Tooltip($$renderer2, {
        show: showTooltip,
        tooltipClass: "p-0 whitespace-nowrap",
        trigger,
        content
      });
    }
  });
}
export {
  TooltipTable as T
};
